// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__95EDh","inner":"Form_inner__32iGG","range":"Form_range__3Tvvh","name":"Form_name__3I2C9","actions":"Form_actions__1v-Bf"};